import { FULL_ABOUT, GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  menus: [],
  value: '',
  result: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  // 介紹
  introduce: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  // 服務窗口
  casement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  // 駐點位置
  stationary: {
    list: [],
    article: [],
    files: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const aboutReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_ABOUT.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_ABOUT.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case FULL_ABOUT.List: {
      return {
        ...state,
        result: { ...action.payload }
      };
    }

    case GLOBAL_CATALOGS.About.Root: {
      return {
        ...state,
        menus: action.payload
      };
    }
    case GLOBAL_CATALOGS.About.Casement.List: {
      return {
        ...state,
        casement: { ...action?.payload }
      };
    }
    case GLOBAL_CATALOGS.About.Stationary.List: {
      return {
        ...state,
        stationary: { ...state?.stationary, ...action?.payload }
      };
    }
    case GLOBAL_CATALOGS.About.Stationary.Article: {
      return {
        ...state,
        stationary: { ...state?.stationary, article: action?.payload }
      };
    }
    case GLOBAL_CATALOGS.About.Stationary.Files: {
      return {
        ...state,
        stationary: { ...state?.stationary, files: action?.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default aboutReducer;
